import icon from 'vue-svgicon';

icon.register({
    'regular/cursor': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M3.465 4.285l6.311 15.327a.75.75 0 0 0 1.224.244l3.447-3.447 3.712 3.713a.752.752 0 0 0 1.061 0l1.06-1.061a.75.75 0 0 0 0-1.061l-3.712-3.712 3.447-3.447a.75.75 0 0 0-.245-1.224L4.444 3.306a.75.75 0 0 0-.979.979z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
